import { Form, Button, Input, Typography, Card } from "antd";
import { Notification } from "../../components/notification/notification";
import "./changePassword.scss";
import { PostRequest } from "../../utils/api";
import { userProfileApis } from "../../utils/ApiURLs";
import { useState } from "react";
import { getEncodedPassword } from "../../utils/utils";
import { CheckCircleOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
const { Text } = Typography;

interface Props {
    username?: string,
    title?: string,
    currentPassword?: string,
    submitCallBack?: Function
}

const ChangePassword: React.FC<Props> = ({
    username,
    currentPassword,
    title = "Change Password",
    submitCallBack
}) => {

    const [form] = Form.useForm();

    const [validations, setValidations] = useState({
        hasUpperCase: false,
        hasSpecialChar: false,
        hasNumber: false,
        isLongEnough: false,
    });

    const onFinish = (values: any) => {

        if (!isNewPasswordValid()) {
            return;
        }

        let data: any = {
            "currentPassword": getEncodedPassword(currentPassword ?? values.old_password),
            "newPassword": getEncodedPassword(values.new_password)
        };

        if (username) {
            data["username"] = username;
        }

        if (submitCallBack) {
            submitCallBack(data);
        } else {

            form.resetFields();

            PostRequest(userProfileApis.passowrdUpdateApi, data).then(() => {
                Notification('success', "Password Changed Successfully");
            }).catch((error: any) => {
                Notification('error', "Failed changing password, Please try again")
            });
        }
    };

    const onFinishFailed = () => {
        Notification('error',
            "Failed changing password, Please try again"
        );
    };

    const isNewPasswordValid = (): boolean => {
        return validations.hasSpecialChar && validations.hasNumber && validations.hasUpperCase && validations.isLongEnough;
    }

    const validatePassword = (password: string) => {
        const validations = {
            hasUpperCase: /[A-Z]/.test(password),
            hasSpecialChar: /[!@#$%^&*(),.?":{}|<>]/.test(password),
            hasNumber: /\d/.test(password),
            isLongEnough: password.length >= 8,
        };
        setValidations(validations);
    };

    const handlePasswordChange = (e: any) => {
        const value = e.target.value;
        validatePassword(value);
    };

    return (
        <Card style={{ width: "98%" }} className="mt-2 mx-2">

            <div className="users-container mt-3">

                <Text className="text-primary font-medium text-2xl">{title}</Text>

                <div>
                    <Form
                        form={form}
                        name="change_password"
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                    >
                        <Form.Item
                            name="old_password"
                            initialValue={currentPassword ?? ""}
                            hidden={currentPassword ? true : false}
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your old password!',
                                },
                            ]}
                            className="my-3"
                        >
                            <Input.Password placeholder="Old Password" />
                        </Form.Item>
                        <Form.Item
                            name="new_password"
                            className="my-3"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your new password!',
                                },
                            ]}
                        >
                            <Input.Password onChange={handlePasswordChange} placeholder="New Password" />
                        </Form.Item>
                        <Form.Item
                            name="confirm_password"
                            className="my-3"
                            dependencies={['new_password']}
                            rules={[
                                {
                                    required: true,
                                    message: 'Please confirm your new password!',
                                },
                                ({ getFieldValue }) => ({
                                    validator(rule, value) {
                                        if (!value || getFieldValue('new_password') === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject('The two passwords that you entered do not match!');
                                    },
                                }),
                            ]}
                        >
                            <Input.Password placeholder="Confirm New Password" />
                        </Form.Item>
                        <Form.Item className="text-right mt-4">
                            <Button className="responsive-button" type="primary" htmlType="submit">
                                Update Password
                            </Button>
                        </Form.Item>
                        <div className="mt-3 text-center">
                            <ul style={{ listStyle: "none" }} id="change_password_rules">
                                <li>
                                    {validations.hasUpperCase ? <CheckCircleOutlined className="text-primary text-xl" /> : <ExclamationCircleOutlined className="text-xl" type="warning" />} <span className="ml-2 text-base">At least one uppercase letter</span>
                                </li>
                                <li>
                                    {validations.hasSpecialChar ? <CheckCircleOutlined className="text-primary text-xl" /> : <ExclamationCircleOutlined className="text-xl" type="warning" />} <span className="ml-2 text-base">At least one special character</span>
                                </li>
                                <li>
                                    {validations.hasNumber ? <CheckCircleOutlined className="text-primary text-xl" /> : <ExclamationCircleOutlined className="text-xl" type="warning" />} <span className="ml-2 text-base"> At least one number </span>
                                </li>
                                <li>
                                    {validations.isLongEnough ? <CheckCircleOutlined className="text-primary text-xl" /> : <ExclamationCircleOutlined className="text-xl" type="warning" />} <span className="ml-2 text-base"> At least 8 characters long </span>
                                </li>
                            </ul>
                        </div>
                    </Form>
                </div>
            </div>
        </Card>

    )
}
export default ChangePassword;
